<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Habitación - Ver</strong>
          </CCardHeader>
          <CCardBody>
            <b-form id="Form">
              <b-row>

                <b-col md="2">
                  <b-form-group label="Tipo de Habitacion :" >
                    <select ref="room"
                    disabled
                      class="form-control"
                      v-model="room.id_type_room" >
                      <option value="">-- Seleccione --</option>
                      <option v-for="item of type_room" :key="item.id_type_room" :value="item.id_type_room">
                        {{ item.name }}
                      </option>
                    </select>
                    
                  </b-form-group>
                </b-col>
          
                <b-col md="2">
                  <b-form-group label="Nro Habitación:">
                    <b-form-input
                      type="text"
                      disabled
                      ref="room_number"
                      v-model="room.room_number"
                    ></b-form-input>
                    
                  </b-form-group>
                </b-col>
      
                <b-col md="2">
                  <b-form-group label="Nro de Camas:">
                    <b-form-input
                      type="number" 
                      step="any"
                      disabled
                      class="text-center"
                      ref="beds"
                      v-model="room.beds"
                    ></b-form-input>
                    
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Desayunos:">
                    <b-form-input
                      type="number" 
                      disabled
                      class="text-center"
                      ref="breakfasts"
                      v-model="room.breakfasts"
                    ></b-form-input>
        
                  </b-form-group>
                </b-col>
   

                <b-col md="2">
                  <b-form-group label="Min. de Huespedes:">
                    <b-form-input
                      type="number" 
                      step="any"
                      disabled
                      class="text-center"
                      ref="minimum_guest"
                      v-model="room.minimum_guest"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Max. de Huespedes:">
                    <b-form-input
                      type="number" 
                      step="any"
                      disabled
                      class="text-center"
                      ref="maximum_guest"
                      v-model="room.maximum_guest"
                    ></b-form-input>
                  </b-form-group>
                </b-col>


                <b-col md="2">
                  <b-form-group label="Precio:">
                    <b-form-input
                      type="number" 
                      step="any"
                      class="text-right"
                      ref="price"
                      disabled
                      v-model="room.price"
                    ></b-form-input>
                    
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Precio Coorporativo:">
                    <b-form-input
                      type="number" 
                      step="any"
                      class="text-right"
                      disabled
                      ref="corporate_price"
                      v-model="room.corporate_price"
                    ></b-form-input>
                    
                  </b-form-group>
                </b-col>

                

       
     
                <b-col md="6">
                  <b-form-group label="Cambiar Foto:">
                    <b-form-file
                    disabled
                      @change="onFileChange"
                      placeholder="Seleccione un foto..."
                      drop-placeholder="Suelta la imagen aquí..."
                    ></b-form-file>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Estado :" label-for="input-1">
                    <select
                      ref="state"
                      v-model="room.state"
                      disabled
                      class="form-control">
                      <option value="1">Activo</option>
                      <option value="0">Inactivo</option>
                    </select>
                  </b-form-group>
                </b-col>
  
         
              

                <b-col md="12">
                  <b-form-group label="Descripción :" required>
                    <b-form-textarea
                      v-model="room.description"
                      rows="2"
                      disabled
                      max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
      
                  <b-col md="12">
                  <b-form-group label="Foto:" class="text-center">
                    <img class="img-fluid text-center" :src="url_base + room.photo" alt="">
                    </b-form-group>
                </b-col>
        

                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-link
                    class="btn form-control btn-primary"
                    :to="{ path: '/habitacion/listar' }"
                    append
                    >REGRESAR</b-link
                  >
                </b-col>
              </b-row>
            </b-form>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";

export default {
  name: "CategoriaView",
  props: ["id_room"],
  data() {
    return {
      module:'Room',
      room: {
        id_room: "",
        id_type_room: "",
        room_number: "",
        photo: "",
        price:0,
        breakfasts:1,
        corporate_price:0,
        beds:1,
        maximum_guest:1,
        minimum_guest:1,
        description: "",
        state: 1
      },
      type_room:[],
      validate: false,
    };
  },
  mounted() {
    this.ListTypeRoom();
    this.ViewRoom();
  },
  methods: {
    ListTypeRoom,
    ViewRoom,

  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};



function ListTypeRoom() {
  let me = this;
  let url = this.url_base + "active-type-room";

  axios({
    method: "GET",
    url: url,
    headers: {
      token: this.token,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.type_room = response.data.result;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {});
}

//ver usuario
function ViewRoom() {
  let id_room = je.decrypt(this.id_room);
  let me = this;
  let url = this.url_base + "room/view/" + id_room;

  axios({
    method: "GET",
    url: url,
    headers: {
      token: this.token,
      module: this.module,
      role: 5,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.room.id_room = response.data.result.id_room;
        me.room.id_type_room = response.data.result.id_type_room;
        me.room.room_number = response.data.result.room_number;
        me.room.photo = response.data.result.photo;
        me.room.breakfasts = response.data.result.breakfasts;
        me.room.price = response.data.result.price;
        me.room.corporate_price = response.data.result.corporate_price;
        me.room.beds = response.data.result.beds;
        me.room.minimum_guest = response.data.result.minimum_guest;
        me.room.maximum_guest = response.data.result.maximum_guest;
        me.room.description = response.data.result.description;
        me.room.state = response.data.result.state;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {

    });
}

</script>
